export default function clickIsInElement(event, element) {
  if (event.target === element) return true;

  return element.contains(event.target);
}
